<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from '@/utils/uiWrapper'
import FooterViewOld from './Old/OldXmlandFileDifMenu.vue'
import NewFooterView from './New/NewXmlandFileDifMenu.vue'

const current = useUiWrapper(FooterViewOld, NewFooterView)
</script>
